define('org/forgerock/openam/ui/user/login/tokens/AuthenticationToken',["exports", "org/forgerock/commons/ui/common/util/CookieHelper", "org/forgerock/commons/ui/common/main/Configuration"], function (exports, _CookieHelper, _Configuration) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.set = set;
    exports.get = get;
    exports.remove = remove;

    var _CookieHelper2 = _interopRequireDefault(_CookieHelper);

    var _Configuration2 = _interopRequireDefault(_Configuration);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /*
     * Copyright 2016-2017 ForgeRock AS. All Rights Reserved
     *
     * Use of this code requires a commercial software license with ForgeRock AS.
     * or with one of its affiliates. All use shall be exclusively subject
     * to such license between the licensee and ForgeRock AS.
     */

    /**
     * The Authentication Token (authId) used by OpenAM to track an authentication session, usually
     * this is an unauthenticated users progress through an authentication chain.
     * @module org/forgerock/openam/ui/user/login/tokens/AuthenticationToken
     */

    var cookieName = "authId";

    function cookieDomains() {
        return _Configuration2.default.globalData.auth.cookieDomains;
    }

    function secureCookie() {
        return _Configuration2.default.globalData.secureCookie;
    }

    function set(token) {
        return _CookieHelper2.default.setCookie(cookieName, token, "", "/", cookieDomains(), secureCookie());
    }

    function get() {
        return _CookieHelper2.default.getCookie(cookieName);
    }

    function remove() {
        return _CookieHelper2.default.deleteCookie(cookieName, "/", cookieDomains());
    }
});

